<template>
  <div id="app">
    <div class="fiexd">
      <div class="container nav">
        <div class="logo">
          <a href="/">
            <img
              src="./assets/img/logo.png"
              alt="安徽中科光电色选机械有限公司"
            />
          </a>
        </div>
        <div class="Pc">
          <Tab>
            <TabBar path="/home">
              <div slot="text" class="size">首页</div>
            </TabBar>
            <TabBar>
              <div slot="text" class="size" @click="campus_btn">校园招聘</div>
            </TabBar>
            <TabBar>
              <div slot="text" class="size" @click="society_btn">社会招聘</div>
            </TabBar>
            <TabBar>
              <div slot="text" class="size" @click="ToAbout">关于我们</div>
            </TabBar>
          </Tab>
        </div>

        <div class="user" @click="HideNav" v-if="$store.getters.token">
          <i
            class="el-icon-user-solid"
            title="会员中心"
            @click="toUser('already')"
          ></i>
          <i
            class="el-icon-switch-button"
            title="退出登录"
            @click="loginOut"
          ></i>
        </div>
        <div @click="HideNav" class="user user_on" v-else>
          <i
            class="el-icon-user-solid"
            title="会员中心"
            @click="toUser('login')"
          ></i>

          <span @click="toUser">登录</span>
        </div>

        <div class="Md">
          <div class="md_img" @click="toggleNav">
            <img src="./assets/img/nav.png" alt="" />
          </div>
        </div>
      </div>
    </div>

    <div
      id="show"
      :class="{ toggle: !toggle }"
      v-show="toggle"
      @click="BoxHide"
    >
      <!-- <div class="user"></div> -->
      <div id="menu">
        <ul>
          <li><router-link to="/home">首页</router-link></li>
          <li @click="campus_btn"><a>校园招聘</a></li>
          <li @click="society_btn"><a>社会招聘</a></li>
          <li @click="ToAbout"><a>关于我们</a></li>
        </ul>
      </div>
    </div>
    <!-- <keep-alive v-if="$route.meta.keepAlive">
      <router-view />
    </keep-alive>
    <router-view v-else /> -->
    <keep-alive exclude="Details,apply,login">
      <router-view />
    </keep-alive>
  </div>
</template>
<script>
import Tab from "@/components/Tab.vue";
import TabBar from "@/components/TabBar.vue";
export default {
  props: {},
  data() {
    return {
      toggle: false,
      Url: "http://www.cn-amd.com/about/about_index/4.html",
    };
  },
  computed: {},
  created() {
    //在页面加载时读取sessionStorage里的状态信息
    // if (sessionStorage.getItem("store")) {
    //   console.log("页面加载时，读缓存数据里的store",this.$store.state);
    //   this.$store.replaceState(
    //     Object.assign(
    //       {},
    //       this.$store.state,
    //       JSON.parse(sessionStorage.getItem("store"))
    //     )
    //   );
    // }
    // //在页面刷新时将vuex里的信息保存到sessionStorage里
    // window.addEventListener("beforeunload", () => {
    //   console.log("页面刷新时，将store写入缓存数据里的",this.$store.state);
    //   sessionStorage.setItem("store", "");
    //   sessionStorage.setItem("store", JSON.stringify(this.$store.state));
    //   sessionStorage.setItem("token", this.$store.state.user.token);
    // });
  },
  mounted() {},
  watch: {},
  methods: {
    toggleNav() {
      this.toggle = !this.toggle;
    },
    HideNav() {
      this.toggle = false;
    },
    BoxHide() {
      this.toggle = !this.toggle;
    },
    toUser(ViewPage) {
      this.$router.push("/user/" + ViewPage);
    },
    // 退出登录
    loginOut() {
      this.$confirm("此操作将退出登录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$store.dispatch("user/logout").then(() => {
          this.$router.push("/home");
          location.reload();
        });
      });
    },
    // 跳转中科网站
    ToAbout() {
      window.open(this.Url, "_blank");
    },

    campus_btn() {
      // 跳转网址 https://app.mokahr.com/m/campus-recruitment/hdzn/151324?locale=zh-CN
      window.open("https://app.mokahr.com/m/campus-recruitment/hdzn/151324?locale=zh-CN");
      // this.$router.push("/campus");
    },
    society_btn() {
      window.open("https://app.mokahr.com/m/social-recruitment/hdzn/151323?locale=zh-CN")
      // this.$router.push("/society");
    },
  },
  components: {
    Tab: Tab,
    TabBar: TabBar,
  },
  
};
</script>

<style lang="less" scoped>
#app {
  overflow: hidden;
}

// 移动端导航css
#show {
  position: fixed;
  top: 1.4rem;
  left: 0;
  height: 100%;
  width: 100%;
  background-color: rgba(29, 29, 29, 0.808);
  z-index: 10;
  animation: slide-in-top 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
  #menu {
    display: flex;
    justify-content: center;
    text-align: center;
    ul {
      li {
        line-height: 1rem;
        a {
          font-size: 0.36rem;
          color: #fff;
        }
      }
    }
  }
}
@keyframes slide-in-top {
  0% {
    -webkit-transform: translateY(-1000px);
    transform: translateY(-1000px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    opacity: 1;
  }
}
.fiexd {
  position: fixed;
  z-index: 11;
  background-color: #fff;
  width: 100%;
  left: 0;
  box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.15);
}
.nav {
  height: 0.8rem;
  display: flex;
  align-items: center;
  position: relative;
  .logo {
    width: 0.8rem;
    display: flex;
    align-items: center;
    a {
      img {
        width: 100%;
      }
    }
  }
  .user {
    width: 0.8rem;
    height: 0.8rem;
    padding: 0.2rem;
    position: absolute;
    right: 0;
    display: flex;
    cursor: pointer;
    align-items: center;
    img {
      width: 100%;
    }
    i {
      font-size: 0.3rem;
      display: flex;
      align-items: center;
    }
  }
  .user_on {
    flex-direction: column;
    justify-content: center;
    span {
      font-size: 0.14rem;
      text-align: center;
    }
  }
  .Md {
    display: none;
  }
}
@media only screen and (min-width: 766px) {
  #show {
    display: none;
  }
}
@media only screen and (max-width: 766px) {
  .nav {
    height: 1.4rem;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .logo {
      width: 1.4rem;
      display: flex;
      align-items: center;
      margin-left: 0.4rem;
      a {
        img {
          width: 100%;
        }
      }
    }
    .Pc {
      display: none;
    }
    .user {
      width: 1.2rem;
      height: 1.2rem;
      right: 1.5rem;
      padding: 0.3rem;
      i {
        font-size: 0.5rem;
      }
      span {
        font-size: 0.24rem;
      }
    }
    .Md {
      display: block;
      height: 100%;
      .md_img {
        height: 100%;
        padding: 0.4rem;
        img {
          height: 100%;
        }
      }
    }
  }
}
</style>
